<template>
    <v-row
            v-if="!!settings"
            class="ma-0"
            dense>
        <v-col
                v-if="!!settings.icon_url"
                dense
                cols="12"
                class="align-content-center align-center text-center">
            <img
                    class="mx-auto"
                    style="max-width: 100%"
                    :src="settings.icon_url">
        </v-col>
        <v-col
                v-if="!!settings.title"
                cols="12">
            <h1 class="text-center">
                {{ settings.title }}
            </h1>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "AccountHeader",
        props: {
            settings: {type: Object, default: () => {}}
        },
        methods: {
            getIconUrl() {
                return this.settings.icon_url
            }
        }
    }
</script>

<style scoped>

</style>